import {useSession} from '@features/auth/authClient';

type Session = ReturnType<typeof useSession>['data'];
let cachedSession: Session | undefined = undefined;

/* eslint-disable react-hooks/globals */
// Hack: https://banani-labs-inc.sentry.io/issues/82919242/?environment=vercel-production&query=is%3Aunresolved&referrer=issue-stream
export function useAuthenticatedSession() {
  const {data, error} = useSession();

  if (!data) {
    if (error && cachedSession) {
      console.warn('Fetch error, using cached session.');
      return cachedSession;
    }

    throw new Error('Not authenticated');
  }

  // Store the cached session in case it becomes temporarily unavailable
  cachedSession = data;

  return data;
}
